import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { isEmpty, isNumber, isNegative } from "lodash";
import { toFixedWithoutRounding } from "../../Utils/constants";
import { useContextSelector } from "use-context-selector";
const HeaderVelkie = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh
  );
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader
  );
  const setSidebarModal = useContextSelector(
    AuthContext,
    (ctx) => ctx.setSidebarModal
  );

  const navigte = useNavigate();
  const location = useLocation();
  return (
    <div
      data-v-91b1c8f7
      id="header"
      className="header h-40px py-1.5 px-2 sticky top-0 z-30 flex justify-between items-center text-11 bg-primary"
    >
      <div data-v-91b1c8f7 className="flex items-center">
        {location?.pathname?.split("/")[1] == "match-detail-velki" ? (
          <div
            onClick={() => navigte("/sports-velki")}
            data-v-91b1c8f7=""
            class="mr-3"
          >
            <i
              data-v-91b1c8f7=""
              class="icon-arrow-left text-20 text-header-icon"
            ></i>
          </div>
        ) : (
          // <div onClick={() => setSidebarModal(true)} className="mr-2.5" data-v-91b1c8f7="">
          //   <i
          //     className="icon-menu text-20 text-header-icon"
          //     data-v-91b1c8f7=""
          //   />
          // </div>
          ''
        )}
        <img
          data-v-91b1c8f7
          width={84}
          height={26}
          alt="logo"
          src={require("../../assets/images/velki-logo.png")}
          className="w-24 h-auto max-h-8 object-contain object-left"
        />
      </div>
      <div data-v-91b1c8f7 className="flex justify-between items-center">
        <div
          data-v-91b1c8f7
          className="w-full max-w-xs h-full py-0.5 flex flex-col justify-between"
        >
          {refreshAmountLoader ? (
            <div className="loading-bar w-full flex items-center justify-center">
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
              <span
                data-v-e8bc8454
                className="w-4px h-4px mr-2 rounded-full bg-header-icon animate-load-bar"
              />
            </div>
          ) : (
            <>
              <p data-v-91b1c8f7 className="mb-1 text-header-text">
                @{user?.user?.username}
              </p>
              <div data-v-91b1c8f7 className="flex flex-row">
                <div data-v-91b1c8f7>
                  <span
                    data-v-91b1c8f7
                    className="mr-1 text-header-dollar font-bold"
                  >
                    BDT
                  </span>
                  <span data-v-91b1c8f7 className="text-header-text">
                    {isNumber(userCoins?.balance)
                      ? toFixedWithoutRounding(userCoins?.balance, 2)
                      : 0.0}
                  </span>
                </div>
                <div data-v-91b1c8f7 className="pl-2.5">
                  <span
                    data-v-91b1c8f7
                    className="mr-1 text-header-dollar font-bold"
                  >
                    Exp
                  </span>
                  <span
                    data-v-91b1c8f7
                    className="text-header-exp bg-header-exp"
                  >
                    ({toFixedWithoutRounding(userCoins?.exp)})
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        <i
          onClick={amounutRefresh}
          data-v-91b1c8f7
          className={`icon-refresh mr-1 ml-2.5 text-20 text-header-icon ${
            refreshAmountLoader ? "rotate" : ""
          }`}
        />
      </div>
    </div>
  );
};

export default HeaderVelkie;
